import styled, { css } from "styled-components";

const ButtonWrapper = styled.button`
  position: relative;
  width: 150px;
  display: flex;
  justify-content: center;
  background-color: transparent;
  color: #ffffff;
  align-items: center;
  font-family: "Poppins";
  line-height: 22px;
  text-align: center;
  font-size: 16px;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 1;

  svg {
    margin-right: 10px;
    font-size: 24px;
  }

  &:hover {
    &::before {
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.35);
    }
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    height: 100%;
    content: "";
    transition: all 0.4s;
    z-index: -1;
  }

  ${({ sm }) =>
    sm &&
    css`
      width: 150px;
      height: 50px;
    `}
  ${({ lg }) =>
    lg &&
    css`
      width: 200px;
      height: 60px;
    `}
    ${({ variant }) =>
    variant === "outline" &&
    css`
      border: 1px solid #FF06B7;
      border-radius: 10px 10px 10px 10px;
      color: #ffffff;
      text-transform: Capitalize;

      &:hover {
        &::before {
          background: #FF06B7;
        }
      }
    `} 
    ${({ variant }) =>
    variant === "hovered" &&
    css`
      background: rgba(255, 255, 255, 0.35);
      color: #ffffff;

      &:hover {
        &::before {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    `} 
    ${({ variant }) =>
    variant === "blue" &&
    css`
      background: #5865f2;
      color: #ffffff;
      border: none;
      &:hover {
        &::before {
          background: #515ddf;
        }
      }
    `}
`;

export default ButtonWrapper;
